/** Preserve the existing protection against malformed square annotations. */
export function guardPdfAnnotations(pdf) {
    if (!pdf || typeof pdf.getPage !== "function" || pdf.__workAnnotationGuardInstalled) return;
    const getPage = pdf.getPage.bind(pdf);
    pdf.getPage = (...args) => getPage(...args).then((page) => {
        if (page.__workAnnotationGuardInstalled || typeof page.getAnnotations !== "function") return page;
        const getAnnotations = page.getAnnotations.bind(page);
        page.getAnnotations = (...parameters) => getAnnotations(...parameters).then((items) => !Array.isArray(items) ? items : items.filter((item) => {
            if (!(item?.subtype === "Square" || item?.annotationType === 5 || item?.annotationType === "Square") || !Array.isArray(item.rect) || item.rect.length < 4) return true;
            const width = Math.abs(Number(item.rect[2]) - Number(item.rect[0]));
            const height = Math.abs(Number(item.rect[3]) - Number(item.rect[1]));
            return Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0;
        }));
        page.__workAnnotationGuardInstalled = true;
        return page;
    });
    pdf.__workAnnotationGuardInstalled = true;
}
